export default __webpack_public_path__ + "static/media/collection-img-sample4@2x.05059253.png";